import Url from '@music/mobile-url';
import {makeActionCreator, makeActionType, getActionType} from '../util/redux';
import {Toast} from '../component/message';
import Request from '../util/fetch';
import History from '../util/history';
import Fizz from '@music/fizz/lib/main';
import yidun from '@music/fizz/lib/yidun';
//other actions
import {worksClearTab, worksEidtItem} from './works';

const mockUserId = Url.CurrentParams.mockUserId || '';

const httpClient = new Fizz();
httpClient.addMiddleware(yidun({pre:true}));
httpClient.addMiddleware(request => {
    request.fetch = (url, opt) => Request.fetch({url, ...opt});
});
  
export const EditType = 'edit';
//创建Types
makeActionType(EditType, ['svrequest', 'svcomplete', 'editCover']);
export const editClear = makeActionCreator(getActionType(EditType, 'clear'));
export const editSuccess = makeActionCreator(getActionType(EditType, 'success'));
export const editFail = makeActionCreator(getActionType(EditType, 'fail'));
export const editSaveComplete = makeActionCreator(getActionType(EditType, 'svcomplete'));
export const editSaveCover = makeActionCreator(getActionType(EditType, 'editCover'));
//查询视频
export const editRequest = (data) => (dispatch) => {
    let nfrom = data.from;
    delete data.from;
    dispatch({
        type : getActionType(EditType, 'request'),
        payload : data
    });
    return Request.fetch({
        url : nfrom ? "/api/cloudvideo/video/tmp/get" : "api/cloudvideo/video/get",
        data : {
            videoId : data.videoId,
            mockUserId,
        }
    })
    .then(function(data){
        //console.log(data);
        dispatch(editSuccess(data));
    })
    .catch(error => {
        let rerr = Request.resolveError(error);
        dispatch(editFail(rerr))
    });
}
//保存视频
export const editSaveRequest = (data) => (dispatch) => {
    dispatch({
        type : getActionType(EditType, 'svrequest')
    });
    /*
        transcode 是否转码
        videoInfo 视频信息
        createEvent 是否同步动态
        //修改时需要保留coverUrl
        _eventFrom来自动态或者朋友
    */
    let videoInfo = data.videoInfo;
    let videoId = videoInfo.videoId;
    let coverUrl = videoInfo.coverUrl;
    delete videoInfo.coverUrl;
    let _eventFrom = data._eventFrom;
    delete data._eventFrom;
    if(videoInfo){
        // videoInfo.title = videoInfo.title.replace(/\\/g, function(){
        //     return '\\\\';
        // });
        data.videoInfo = JSON.stringify(videoInfo);
    }
    //前端修改时需要该数据
    videoInfo.coverUrl = coverUrl;
    data.mockUserId = mockUserId;
    //console.log(videoInfo, data);
    return httpClient.fetch(videoId ? "api/cloudvideo/video/update" : "api/cloudvideo/video/publish", {
        checkToken: true,
        query: data
    }).then(function(result){
        /*
            新增发布成功，定位到我的作品第二个tab且重新获取数据
            修改成功，定位在我的作品第一个tab且只需要重新修改该视频数据即可
        */
        dispatch(editSaveComplete({success : true}));
        
            if(videoId){
                Toast({
                    type : 'success',
                    text : '视频信息修改成功'
                });
                History.push('/mywork');
                dispatch(worksEidtItem(videoInfo));
            }
            else{
                History.push('/mywork?tab=1');
                dispatch(worksClearTab(1));
            }
    })
    .catch(error => {
        let rerr = Request.resolveError(error);
        Toast({
            type : 'error',
            text : rerr.msg
        });
        dispatch(editSaveComplete({}))
    });
}




// WEBPACK FOOTER //
// ./client/action/edit.js